type StartEncounterIds = {
  patientId: string
  intakeId: string
}

export const buildStartEncounterPayload = ({ patientId, intakeId }: StartEncounterIds) => ({
  data: {
    attributes: {
      encounter_type: 'outpatient'
    },
    relationships: {
      intake: {
        data: {
          id: intakeId,
          type: 'intake'
        }
      },
      patient: {
        data: {
          id: patientId,
          type: 'patient'
        }
      }
    },
    type: 'encounter'
  }
})
